<template>
    <v-btn @click="onClick" content="Projects" v-tippy="{placement: 'left'}">
        <i class="material-icons">apps</i>
    </v-btn>
</template>

<script>
export default {
    methods: {
        onClick() {
            this.$store.dispatch("Projects/setModalSelectedProject", this.$store.state.Projects.project.id);
            window.UI.showModal(window.$("#project-selector-modal"));
        },
    },
};
</script>